import ModelAttribute from '../../../shared/aifans/model/ModelAttritube'

const ChatModelTraits = (props: any) => {
  return (
    <div class="mb-12 md:mb-0">
      <div class="mb-2 px-8 pt-[18px] font-clash">ABOUT ME:</div>
      <div
        class={`grid grid-cols-2 gap-x-8 gap-y-3 border-b border-b-cosplay-gray-100 px-8 pb-[18px]`}
      >
        <ModelAttribute title="PERSONALITY" value={props.personality} />
        <ModelAttribute title="OCCUPATION" value={props.occupation} />
        <ModelAttribute title="HOBBIES" value={props.hobbies} />
        <ModelAttribute title="RELATIONSHIP" value={props.relationship} />
      </div>
      <div class={`grid grid-cols-2 gap-x-8 gap-y-3 px-8 py-[18px]`}>
        <ModelAttribute title="BODY" value={props.bodyType} />
        <ModelAttribute title="AGE" value={props.age} />
        <ModelAttribute title="BUTT" value={props.butt} />
        <ModelAttribute title="Hair" value={props.hair} />
        <ModelAttribute title="BREASTS" value={props.breasts} />
        <ModelAttribute title="ETHNICITY" value={props.ethnicity} />
      </div>
    </div>
  )
}

export default ChatModelTraits
